import { ROUTES } from './routes';

/**
 * Разбор `?startapp=` — параметра запуска мини-аппа.
 *
 * Кнопки бота ведут не «в приложение», а на конкретный экран: «Посмотреть
 * рейтинг» обязана открыть Рейтинг, а не главную. Бэкенд дописывает
 * параметр к адресу (`notification-renderer.ts`), Telegram привозит его
 * в `initDataUnsafe.start_param` — разобрать его должен клиент.
 *
 * **Список закрытый, и это главное свойство разбора.** Через тот же
 * параметр приезжают реферальные коды `ref_XXXX`, и завтра приедет что-то
 * ещё: превращать произвольную строку в путь нельзя — это чужой ввод,
 * пусть и подписанный. Неизвестное значение здесь молча даёт `null`,
 * и приложение открывается там же, где открылось бы без параметра.
 *
 * Реферальному коду клиентского разбора не нужно вовсе: его читает сервер
 * из `initData`, где подпись проверена ключом бота.
 */
export interface StartParamTarget {
  /** Путь маршрутизатора. */
  path: string;
  /** Поисковая строка вместе с `?`, если экрану нужен параметр. */
  search: string;
}

/**
 * Период Рейтинга едет в адресе, а не в состоянии компонента: адрес
 * переживает перерисовку и работает, если ссылку просто открыли.
 *
 * `Map`, а не объект: у объекта поиск по чужой строке проваливается
 * в прототип, и `TARGETS['__proto__']` вернул бы не `undefined`, а член
 * `Object.prototype` — то есть «неизвестное значение» превратилось бы
 * в непустой ответ. У `Map` цепочки прототипов нет вовсе.
 */
const TARGETS = new Map<string, StartParamTarget>([
  ['rating_week', { path: ROUTES.rating, search: '?period=week' }],
  ['rating_month', { path: ROUTES.rating, search: '?period=month' }],
  // Кнопка в итоге Месячного розыгрыша: «посмотреть призы следующего
  // месяца в разделе «Розыгрыши»»
  ['draws', { path: ROUTES.draws, search: '' }],
]);

export function resolveStartParam(raw: string | null): StartParamTarget | null {
  if (!raw) return null;
  return TARGETS.get(raw) ?? null;
}

/** Адрес целиком — то, что отдаётся `navigate`. */
export function startParamHref(target: StartParamTarget): string {
  return `${target.path}${target.search}`;
}
